import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectServiceFilesService } from '@catmodules/models/project-service-files/services/project-service-files.service';
import { UIBaseModule } from '@catui/ui-base.module';
import { UIFormModule } from '@catuiform/ui-form.module';
import { ButtonModule, DataTableModule } from 'primeng/primeng';
import { ProjectServiceFilesComponent } from './components/project-service-files/project-service-files.component';
import { DialogModule } from "primeng/primeng";

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    UIBaseModule,
    UIFormModule,
    ButtonModule,
    DialogModule
  ],
  declarations: [ProjectServiceFilesComponent],
  providers: [ProjectServiceFilesService],
})
export class ProjectServiceFilesModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-service-files/project-service-files.module.ts